import React from "react";
import Map from "../map";
import parseWithIcons from "../../utils/parseWithIcons";

const ContenuDynamiqueCarte = ({ data }) => {
  let blocLeft, blocRight;

  let renderCarte = () => {
    return (
      <div className="carte">
        <Map />
      </div>
    );
  };

  let renderText = (dir) => {
    return <div className={`text ${dir}`}>{parseWithIcons(data.texte)}</div>;
  };

  if (data.texte) {
    if (data.placementDeLaCarte === "droite") {
      blocLeft = renderText("left");
      blocRight = renderCarte("right");
    } else {
      blocLeft = renderCarte("left");
      blocRight = renderText("right");
    }
  }

  return (
    <div className="dynamic texte-carte">
      <div className="inner">
        {data.texte && [
          <div className="bloc-left" key="1">
            {blocLeft}
          </div>,
          <div className="bloc-right" key="2">
            {blocRight}
          </div>,
        ]}
        {!data.texte && <Map />}
      </div>
    </div>
  );
};

export default ContenuDynamiqueCarte;
